// Phase 18 Plan 06 — POLISH-11 $typography persistent atom.
//
// Toggled from Settings → Accessibility → Typeface segmented pill
// (TypographyToggle.tsx). RootApp mirrors the value onto
// documentElement.dataset.typography so [data-typography="opendyslexic"]
// swaps --font-family-body to OpenDyslexic (self-hosted under
// apps/web/public/fonts/, Manrope fallback per UI-SPEC §Error state).

import { persistentAtom } from '@nanostores/persistent'

export type Typography = 'system' | 'opendyslexic'

export const TYPOGRAPHIES: ReadonlyArray<Typography> = [
  'system',
  'opendyslexic',
]
export const DEFAULT_TYPOGRAPHY: Typography = 'system'

export function isTypography(v: unknown): v is Typography {
  return v === 'system' || v === 'opendyslexic'
}

export const $typography = persistentAtom<Typography>(
  'runegambit.typography',
  DEFAULT_TYPOGRAPHY,
  {
    encode: (v) => v,
    decode: (s) => (isTypography(s) ? s : DEFAULT_TYPOGRAPHY),
  },
)
